import {JQueryStatic} from 'jquery';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {GlobalService} from '../../service/global.service';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {TipoPeriodicidade} from '../../model/constantes';
import {ModalService} from '../../service/modal.service';
import {FtaService} from '../../service/fta.service';
import {UtilApi} from '../../service/api/util.api';
import {ConstantesApiService} from '../../service/api/constantes.api';
import {CatalogoApiService} from '../../service/api/catalogo.api';
import {DetalhamentoApiService} from '../../service/api/detalhamento.api';
import {PesquisasFiltroApiService} from '../../service/api/pesquisas-filtro.api';
import {
    Cliente, InstalacaoProduto, Servico, Evento, EventoTransmissao, OrigemTransmissao, DestinoTransmissao, Parametro,
    ParametroConteudo, UserAplicacao, SubfluxoPossivel, Dependencia, EventoOperacao, Operacao
} from '../../model/catalogo';
import {userAutorizador} from '../../model/usuario';

declare var $: JQueryStatic;

@Component({
    selector: 'fluxo-cliente-interno',
    templateUrl: './fluxo-cliente-interno.html',
    styleUrls: ['./fluxo-cliente-interno.css']
})

export class FluxoClienteInternoComponent implements OnInit {

    constructor(private globalService: GlobalService, private constantesService: ConstantesApiService, private modalService: ModalService,
                private ftaService: FtaService, public pesquisaService: PesquisasFiltroApiService, public detalhamentoService: DetalhamentoApiService,
                private utilApi: UtilApi, private catalogoApi: CatalogoApiService, private router: Router, private formBuilder: FormBuilder,
    ) {
    }

    paginaAtual = 'principal';
    numPagina = 1;
    totalPaginas = 3;
    numRunTask = 1;
    numEvento = 1;

    montaArqDestino: string = '';

    periodicidades: Array<TipoPeriodicidade> = new Array<TipoPeriodicidade>();
    clientesMF: Array<Cliente> = new Array<Cliente>();
    InstalacoesMF: Array<InstalacaoProduto> = new Array<InstalacaoProduto>();

    clienteOrigem: Cliente = null;
    clienteDestino: Cliente = null;
    instalacaoOrigem: InstalacaoProduto = null;
    instalacaoDestino: InstalacaoProduto = null;
    servicosVinculados: Array<Servico> = new Array<Servico>();
    operacaoConversaoLayout: Operacao = null;
    listaMapas: Array<string> = new Array<string>();
    novoMapa: string = '';

    nome = new FormControl('', [Validators.required]);
    descricao = new FormControl('', [Validators.required]);
    codTipoPeriodicidade = new FormControl('1', []);
    servicos = new FormControl({value: '', disabled: true}, Validators.required);

    /* Origem */
    tipoOrigem = new FormControl('0', [Validators.required]);
    dirOrigem = new FormControl('', []);
    arqOrigem = new FormControl('', []);
    ambienteMFOrigem = new FormControl('0', []);
    hostnameOrigem = new FormControl('', []);
    uorOrigem = new FormControl('', []);
    tpArqOrigem = new FormControl('TEXT', []);
    aposTransf = new FormControl('1', []);
    moverPara = new FormControl({value: '', disabled: true});
    tratamento = new FormControl('false', []);

    /* Operações */
    descriptografar = new FormControl(false, []);
    descompactar = new FormControl(false, []);
    layout = new FormControl(false, []);
    compactar = new FormControl(false, []);
    tipoArqCompactado = new FormControl('ZIP', []);
    tipoArqCompactado2 = new FormControl('ZIP', []);
    tpLayout = new FormControl('', []);
    inserirHeader = new FormControl('', []);
    conteudoHeader = new FormControl('', []);
    conteudoTrailer = new FormControl('', []);
    criptografar = new FormControl(false, []);

    /* Destino */
    tipoDestino = new FormControl('0', [Validators.required]);
    dirDestino = new FormControl('', []);
    arqDestino = new FormControl('', []);
    usarNmArqOrigem = new FormControl('true', []);
    usarArqOrigem = new FormControl('false', []);
    ambienteMFDestino = new FormControl('0', []);
    hostnameDestino = new FormControl('', []);
    uorDestino = new FormControl('', []);
    arqExistente = new FormControl('RPL', []);
    recfm = new FormControl('FB', []);
    lrecl = new FormControl('', []);
    blksize = new FormControl('', []);
    rotinaDestino = new FormControl('', []);

    fluxoForm: FormGroup = this.formBuilder.group({
        nome: this.nome,
        descricao: this.descricao,
        codTipoPeriodicidade: this.codTipoPeriodicidade,
        servicos: this.servicos,

        /* Origem */
        tipoOrigem: this.tipoOrigem,
        dirOrigem: this.dirOrigem,
        arqOrigem: this.arqOrigem,
        ambienteMFOrigem: this.ambienteMFOrigem,
        hostnameOrigem: this.hostnameOrigem,
        uorOrigem: this.uorOrigem,
        tpArqOrigem: this.tpArqOrigem,
        aposTransf: this.aposTransf,
        moverPara: this.moverPara,
        /* TODO - Mover com Timestamp */

        /* Operações */
        descriptografar: this.descriptografar,
        descompactar: this.descompactar,
        layout: this.layout,
        tpLayout: this.tpLayout,
        compactar: this.compactar,
        tipoArqCompactado: this.tipoArqCompactado,
        tipoArqCompactado2: this.tipoArqCompactado2,
        inserirHeader: this.inserirHeader,
        conteudoHeader: this.conteudoHeader,
        conteudoTrailer: this.conteudoTrailer,
        criptografar: this.criptografar,

        /* Destino */
        tipoDestino: this.tipoDestino,
        dirDestino: this.dirDestino,
        arqDestino: this.arqDestino,
        ambienteMFDestino: this.ambienteMFDestino,
        hostnameDestino: this.hostnameDestino,
        uorDestino: this.uorDestino,
        arqExistente: this.arqExistente,
        recfm: this.recfm,
        lrecl: this.lrecl,
        blksize: this.blksize,
        rotinaDestino: this.rotinaDestino
    });

    tooltips: Array<string> = [];

    ngOnInit() {
        this.globalService.loading = true;
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, FluxoClienteInternoComponent.prototype.carregarConstantes);
        this.utilApi.invocacaoRemotaComRetry(5, 1000, this, FluxoClienteInternoComponent.prototype.carregarOperacaoLayout);
        this.globalService.loading = false;
        this.montaArqDestino = '';
    }

    carregarConstantes() {
        this.globalService.loading = true;
        this.constantesService.buscaTipoPeriodicidade(0)
            .subscribe(periodicidades => {
                this.periodicidades = periodicidades as Array<TipoPeriodicidade>;
                this.globalService.loading = false;
            });
    }

    mudaPagina(direcao) {
        if (direcao == 'avancar') {
            this.numPagina++;
            if (this.paginaAtual == 'principal') {
                this.paginaAtual = 'origem';
            } else {
                if (this.tratamento.value == 'true' && this.paginaAtual == 'origem') {
                    this.paginaAtual = 'operacao';
                } else {
                    this.paginaAtual = 'destino';
                }
            }
        } else {
            this.numPagina--;
            if (this.paginaAtual == 'destino') {
                if (this.tratamento.value == 'true') {
                    this.paginaAtual = 'operacao';
                } else {
                    this.paginaAtual = 'origem';
                }
            } else if (this.paginaAtual == 'operacao') {
                this.paginaAtual = 'origem';
            } else {
                this.paginaAtual = 'principal';
            }
        }
    }

    limparCamposOrigem() {
        this.ambienteMFOrigem.setValue('0');
        this.tpArqOrigem.setValue('TEXT');
        this.aposTransf.setValue('1');
        this.apagarHostname('origem');
        this.apagarUOR('origem');
        this.eventoAposTransf();
        this.montaArqDestino = '';
        this.numRunTask = 1;
        this.tratamento.setValue('false');
        this.limparOperacoes();
    }

    limparCamposDestino() {
        this.ambienteMFDestino.setValue('0');
        this.arqExistente.setValue('RPL');
        this.recfm.setValue('FB');
        this.lrecl.setValue('');
        this.blksize.setValue('');
        this.rotinaDestino.setValue('');
        this.apagarHostname('destino');
        this.apagarUOR('destino');
        this.usarArqOrigem.setValue('false');
        this.usarNmArqOrigem.setValue('true');
        this.usarNomeArquivoOrigem();
        this.montaArqDestino = '';
        this.numRunTask = 1;
    }

    eventoAposTransf() {
        if (this.aposTransf.value == '3') {
            this.moverPara.enable();
        } else {
            this.moverPara.setValue('');
            this.moverPara.disable();
        }
    }

    tratamentoArquivo() {
        if (this.tratamento.value == 'true') {
            this.totalPaginas++;
        } else {
            this.limparOperacoes();
        }
    }

    limparOperacoes() {
        this.totalPaginas = 3;
        this.compactar.setValue(false);
        this.descompactar.setValue(false);
        this.layout.setValue(false);
        this.inserirHeader.setValue(false);
        this.tipoArqCompactado.setValue('ZIP');
        this.tipoArqCompactado2.setValue('ZIP');
        this.tpLayout.setValue('');
        this.conteudoHeader.setValue('');
        this.conteudoTrailer.setValue('');
    }

    usarNomeArquivoOrigem() {
        if (this.usarNmArqOrigem.value == 'true') {
            this.arqDestino.setValue('&ArquivoOrigem.');
        } else {
            this.arqDestino.setValue('');
        }
    }

    montarArqOrigem() {
        if (this.tipoOrigem.value == 'mainframe') {
            this.arqOrigem.setValue(this.arqOrigem.value.toUpperCase());
        }
    }

    // Substitui as variáveis do nome do arquivo digitado pelo usuário, deixando-as no padrão necessário à criação do FTA
    preparaVariaveisNomeArquivo(arq: string): string {
        arq = arq.replace(/\$C/g, '&ArquivoOrigem')
            .replace(/\]/g, '].')
            .replace(/\$DT_DD/g, '&$DT_DD.')
            .replace(/\$DT_MM/g, '&$DT_MM.')
            .replace(/\$DT_AAAA/g, '&$DT_AAAA.')
            .replace(/\$DT_AA/g, '&$DT_AA.')
            .replace(/\$HR_HH/g, '&$HR_HH.')
            .replace(/\$HR_hh/g, '&$HR_hh.')
            .replace(/\$HR_MM/g, '&$HR_MM.')
            .replace(/\$HR_SS/g, '&$HR_SS.')
            .replace(/\$HR_PR/g, '&$HR_PR.')
            .replace(/\$TIMESTAMP/g, '&$TIMESTAMP.');
        return arq.trim();
    }

    // Substitui as variáveis do nome do arquivo destino para exibição na página
    montarArqDestino() {

        if (this.tipoDestino.value == 'mainframe') {
            this.arqDestino.setValue(this.arqDestino.value.toUpperCase());
        }

        let temp: string = this.arqDestino.value;
        let origem: string = this.arqOrigem.value;

        let now = new Date();

        temp = temp.replace(/\$DT_DD/g, this.addHtml(now.getDate().toString(), 2))
            .replace(/\$DT_MM/g, this.addHtml(now.getMonth().toString(), 2))
            .replace(/\$DT_AAAA/g, this.addHtml(now.getFullYear().toString(), 0))
            .replace(/\$DT_AA/g, this.addHtml(now.getFullYear().toString().substr(2, 2), 2))
            .replace(/\$HR_HH/g, this.addHtml(now.getHours().toString(), 2))
            .replace(/\$HR_hh/g, this.addHtml('hh', 0))
            .replace(/\$HR_MM/g, this.addHtml(now.getMinutes().toString(), 2))
            .replace(/\$HR_SS/g, this.addHtml(now.getSeconds().toString(), 2))
            .replace(/\$HR_PR/g, this.addHtml('AM/PM', 0))
            .replace(/\$TIMESTAMP/g, this.addHtml(now.getTime().toString(), 0));

        if (this.usarArqOrigem.value == 'true' && origem != '') {
            let variaveisOrigem = temp.match(/\$C\[[0-9-]+:[0-9-]+\]/g);
            if (variaveisOrigem != null) {
                variaveisOrigem.forEach(elemento => {
                    let char = elemento.replace('$C[', '').replace(']', '').split(':');
                    if (parseInt(char[1]) > origem.length || parseInt(char[0]) > origem.length) {
                        temp = this.addHtml('Erro: Não é possível substituir a variável ' + elemento + ': caractere final é maior que o tamanho do arquivo', 0);
                    } else {
                        temp = temp.replace(elemento, this.addHtml(origem.substring(parseInt(char[0]) - 1, parseInt(char[1])), 0));
                    }
                });
            }
        }

        this.montaArqDestino = temp;
    }

    // Transforma o nome do arquivo em regEx
    nomeArqToRegex(str: string) {
        return this.preg_quote(str.trim()).replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
    }

    preg_quote(str: string) {
        return (str + '').replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&');
    }

    // Adiciona tag HTML nas partes do nome do arquivo que foram substituídas para exibição na página
    addHtml(str: string, digitos: number) {
        if (digitos != 0) {
            if (str.length < digitos) {
                str = '00000000000000000' + str;
                str = str.substr(-digitos);
            }
        }
        return '<span class=\'text-success\'><strong>' + str + '</strong></span>';
    }

    // Adiciona uma barra no final dos campos de diretório de acordo com o conteúdo do campo "/" ou "\"
    barraDiretorio(local: string) {
        if (local == 'origem' && this.dirOrigem.value != '') {
            this.dirOrigem.setValue(this.dirOrigem.value.trim().replace(/\?/g, '').replace(/\*/g, ''));
            if (this.dirOrigem.value.indexOf('\\') > -1 && this.dirOrigem.value.charAt(this.dirOrigem.value.length - 1) != '\\') {
                this.dirOrigem.setValue(this.dirOrigem.value + '\\');
            } else if (this.dirOrigem.value.indexOf('/') > -1 && this.dirOrigem.value.charAt(this.dirOrigem.value.length - 1) != '/') {
                this.dirOrigem.setValue(this.dirOrigem.value + '/');
            }
        } else if (local == 'destino' && this.dirDestino.value != '' && this.dirDestino.value.charAt(this.dirDestino.value.length - 1) != '/') {
            this.dirDestino.setValue(this.dirDestino.value.trim().replace(/\?/g, '').replace(/\*/g, ''));
            if (this.dirDestino.value.indexOf('\\') > -1 && this.dirDestino.value.charAt(this.dirDestino.value.length - 1) != '\\') {
                this.dirDestino.setValue(this.dirDestino.value + '\\');
            } else if (this.dirDestino.value.indexOf('/') > -1 && this.dirDestino.value.charAt(this.dirDestino.value.length - 1) != '/') {
                this.dirDestino.setValue(this.dirDestino.value + '/');
            }
        } else if (local == 'moverPara' && this.moverPara.value != '' && this.moverPara.value.charAt(this.moverPara.value.length - 1) != '/') {
            this.moverPara.setValue(this.moverPara.value.trim().replace(/\?/g, '').replace(/\*/g, ''));
            if (this.moverPara.value.indexOf('\\') > -1 && this.moverPara.value.charAt(this.moverPara.value.length - 1) != '\\') {
                this.moverPara.setValue(this.moverPara.value + '\\');
            } else if (this.moverPara.value.indexOf('/') > -1 && this.moverPara.value.charAt(this.moverPara.value.length - 1) != '/') {
                this.moverPara.setValue(this.moverPara.value + '/');
            }
        }
    }

    selecionarUORBlur(local: string) {
        if (local == 'origem' && this.uorOrigem.value != '') {
            this.selecionarUOR(local);
        } else if (local == 'destino' && this.uorDestino.value != '') {
            this.selecionarUOR(local);
        }
    }

    selecionarUOR(local: string) {
        let uor = '';
        if (local == 'origem') {
            uor = this.uorOrigem.value.split(' - ')[0];
        } else {
            uor = this.uorDestino.value.split(' - ')[0];
        }

        this.modalService.abrirPaginaModal('cliente-modal', {}, {
            'tipoCliente': '3',
            'campoBusca': uor,
            'selecionaAutomatico': true
        }, 'Selecionar UOR', 'Fechar')
            .subscribe(cliente => {
                if (cliente != null) {

                    this.globalService.loading = true;
                    let filtros: Array<any> = new Array<any>();
                    filtros.push({
                        'filtroInstalacaoProduto': {
                            'nomeItemConfiguracaoProduto': 'SIA',
                            'clienteVinculado': cliente
                        }
                    });

                    this.pesquisaService.filtraInstalacaoProduto(filtros)
                        .subscribe(
                            listaInstalacoes => {
                                this.globalService.loading = false;
                                this.vincularUOR(local, cliente, listaInstalacoes[0]);
                            },
                            erro => {
                                if (erro.status == 404) {
                                    this.catalogoApi.vinculacaoClienteInstalacaoProduto(this.globalService.getConfiguracao().codInstalacaoSIAPadrao, 1, cliente)
                                        .subscribe(
                                            resp => {
                                                let inst = new InstalacaoProduto();
                                                inst.codigo = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
                                                inst.versao = 0;
                                                this.vincularUOR(local, cliente, inst);
                                            },
                                            error => {
                                                this.modalService.exibirMensagem('Erro', 'Erro ao vincular UOR à instalação SIA Padrão', 'Fechar');
                                            });
                                }
                                this.globalService.loading = false;
                            }
                        );
                }
            });
    }

    vincularUOR(local: string, cliente: Cliente, instalacao: InstalacaoProduto) {
        if (local == 'origem') {
            this.clienteOrigem = cliente;
            this.instalacaoOrigem = instalacao;
            this.uorOrigem.setValue(cliente.uor.codUor + ' - ' + cliente.uor.nomeDependencia);
            this.uorOrigem.disable();
        } else {
            this.clienteDestino = cliente;
            this.instalacaoDestino = instalacao;
            this.uorDestino.setValue(cliente.uor.codUor + ' - ' + cliente.uor.nomeDependencia);
            this.uorDestino.disable();
        }

    }

    apagarUOR(local: string) {
        if (local == 'origem') {
            this.clienteOrigem = null;
            this.uorOrigem.setValue('');
            this.uorOrigem.enable();
        } else {
            this.clienteDestino = null;
            this.uorDestino.setValue('');
            this.uorDestino.enable();
        }
    }

    selecionarHostnameBlur(local: string) {
        if (local == 'origem' && this.hostnameOrigem.value != '') {
            this.selecionarHostname(local);
        } else if (local == 'destino' && this.hostnameDestino.value != '') {
            this.selecionarHostname(local);
        }
    }

    selecionarHostname(local: string) {
        let hostname = '';
        if (local == 'origem') {
            if ($('#botaoSelecionarHostnameOrigem').prop('disabled') == true) {
                return false;
            }
            hostname = this.hostnameOrigem.value;
        } else {
            if ($('#botaoSelecionarHostnameDestino').prop('disabled') == true) {
                return false;
            }
            hostname = this.hostnameDestino.value;
        }

        this.modalService.abrirPaginaModal('hostname-modal', {}, {
            'campoBusca': hostname,
            'nomeItemConfiguracao': 'Connect_Direct', 'cadastraNovaInstalacao': true
        }, 'Selecionar Hostname', 'Fechar')
            .subscribe(resp => {
                if (resp != null) {
                    let inst = resp.instalacao;
                    let cli = resp.cliente;
                    let hostnames = '';

                    inst.itemConfiguracaoVinculado.forEach(item => {
                        hostnames == '' ? hostnames = item : hostnames = hostnames + ', ' + item;
                    });

                    if (local == 'origem') {
                        this.instalacaoOrigem = inst;
                        this.clienteOrigem = cli;
                        this.hostnameOrigem.setValue(hostnames);
                        this.hostnameOrigem.disable();
                        $('#botaoSelecionarHostnameOrigem').prop('disabled', true);
                    } else {
                        this.instalacaoDestino = inst;
                        this.clienteDestino = cli;
                        this.hostnameDestino.setValue(hostnames);
                        this.hostnameDestino.disable();
                        $('#botaoSelecionarHostnameDestino').prop('disabled', true);
                    }

                }
            });
    }

    apagarHostname(local: string) {
        if (local == 'origem') {
            this.instalacaoOrigem = null;
            this.hostnameOrigem.setValue('');
            this.hostnameOrigem.enable();
            $('#botaoSelecionarHostnameOrigem').prop('disabled', false);
        } else {
            this.instalacaoDestino = null;
            this.hostnameDestino.setValue('');
            this.hostnameDestino.enable();
            $('#botaoSelecionarHostnameDestino').prop('disabled', false);
        }
    }

    selecionarServico() {
        let servico = this.servicos.value;
        let selecionados = '';

        if (this.servicosVinculados.length > 0) {
            selecionados = JSON.stringify(this.servicosVinculados);
        }

        this.modalService.abrirPaginaModal('servico-modal', {}, {'selecionados': selecionados}, 'Selecionar Serviços', 'Fechar')
            .subscribe(serv => {
                if (serv != null) {
                    this.servicosVinculados = serv;
                    let servs: string = '';
                    serv.forEach(element => {
                        servs = servs + element.nome + '\n';
                    });
                    this.servicos.setValue(servs);
                }
            });
    }

    apagarServico() {
        this.servicosVinculados.length = 0;
        this.servicos.setValue('');
    }

    // Busca informações sobre a operação de conversão de layout
    carregarOperacaoLayout() {
        this.globalService.loading = true;
        this.detalhamentoService.detalhaOperacao(this.globalService.getConfiguracao().codOperacaoConverteLayout, 0)
            .subscribe(
                operacao => {
                    this.operacaoConversaoLayout = operacao as Operacao;
                    operacao.parmEntrada.forEach(op => {
                        if (op.nome == 'mapaConversao') {
                            this.listaMapas = op.conteudoPadrao;
                        }
                    });
                    this.globalService.loading = false;
                },
                erro => {
                    if (erro.status == 404) {
                    }
                    this.globalService.loading = false;
                }
            );
    }

    // Verificar se layout selecionado = "Outros"
    verificarMapa() {
        let valor = $('select[id=mapaConversao]').val();
        if (valor == '999') {
            this.modalService.abrirPaginaModal('mapa-layout-modal', {}, {'mapas': this.listaMapas}, 'Mapa de Conversão', 'Fechar')
                .subscribe(resp => {
                    if (resp != '') {
                        this.novoMapa = resp;
                        $('#novo-mapa-conversao').show();
                    } else {
                        this.novoMapa = '';
                        $('#novo-mapa-conversao').hide();
                    }
                });
        } else {
            this.novoMapa = '';
            $('#novo-mapa-conversao').hide();
        }
    }

    recuperaDadosMF(local) {

        let ambiente = '';
        let codUserApl = 0;
        let codInstalacao = 0;

        if (local == 'origem') {
            ambiente = this.fluxoForm.value.ambienteMFOrigem;
        } else {
            ambiente = this.fluxoForm.value.ambienteMFDestino;
        }

        switch (ambiente) {
            case 'desenv':
                codUserApl = this.globalService.getConfiguracao().codClienteMF_desenv;
                codInstalacao = this.globalService.getConfiguracao().codInstalacaoMF_desenv;
                break;
            case 'homologa':
                codUserApl = this.globalService.getConfiguracao().codClienteMF_homologa;
                codInstalacao = this.globalService.getConfiguracao().codInstalacaoMF_homologa;
                break;
            case 'br':
                codUserApl = this.globalService.getConfiguracao().codClienteMF_br;
                codInstalacao = this.globalService.getConfiguracao().codInstalacaoMF_br;
                break;
            case 'b2':
                codUserApl = this.globalService.getConfiguracao().codClienteMF_b2;
                codInstalacao = this.globalService.getConfiguracao().codInstalacaoMF_b2;
                break;
        }

        let clienteMF = new Cliente();
        clienteMF.codTipoCliente = 1;
        clienteMF.userAplicacao = new UserAplicacao();
        clienteMF.userAplicacao.codUserAplicacao = codUserApl;
        clienteMF.userAplicacao.versaoUserAplicacao = 1;

        let instalacaoMF: InstalacaoProduto = new InstalacaoProduto();
        instalacaoMF.codigo = codInstalacao;
        instalacaoMF.versao = 1;

        if (local == 'origem') {
            this.clienteOrigem = clienteMF;
            this.instalacaoOrigem = instalacaoMF;
        } else {
            this.clienteDestino = clienteMF;
            this.instalacaoDestino = instalacaoMF;
        }
    }

    // Verifica se a instalação de produto já existe ou se deve ser inserida na base de dados
    verificarInstalacaoProduto() {
        // Instalação Origem
        if (this.instalacaoOrigem.codigo == 0) {
            this.catalogoApi.criaEditaInstalacaoProduto(0, 0, this.instalacaoOrigem)
                .subscribe(
                    resp => {
                        this.instalacaoOrigem.codigo = resp.codigoCriado;
                        this.instalacaoOrigem.versao = resp.versaoCriada;
                    },
                    error => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao salvar o hostname de origem informado', 'Fechar');
                    });
        }

        // Instalação Destino
        if (this.instalacaoDestino.codigo == 0) {
            this.catalogoApi.criaEditaInstalacaoProduto(0, 0, this.instalacaoDestino)
                .subscribe(
                    resp => {
                        this.instalacaoDestino.codigo = resp.codigoCriado;
                        this.instalacaoDestino.versao = resp.versaoCriada;
                    },
                    error => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao salvar o hostname de destino informado', 'Fechar');
                    });
        }
    }

    // Verifica se o cliente já existe ou se deve ser inserido na base de dados
    verificarCliente() {
        // TODO - Deixar síncrono
        let user: userAutorizador = new userAutorizador();
        // Verifica Cliente Origem
        if (this.clienteOrigem.codTipoCliente == 1 && this.clienteOrigem.userAplicacao.codUserAplicacao == 0) {
            user.username = this.clienteOrigem.userAplicacao.nomeUserAplicacao;
            user.descricao = this.clienteOrigem.userAplicacao.descricaoUserAplicacao;
            user.senha = 'connect';
            user.msgAlarmeSia = 'msgAlarmeSia';
            user.qtdMinGeracaoAlarmeSia = 1;

            this.catalogoApi.criaEditaUsuario(0, 0, user)
                .subscribe(
                    resp => {
                        this.clienteOrigem.userAplicacao.codUserAplicacao = resp.codigo;
                        this.clienteOrigem.userAplicacao.versaoUserAplicacao = resp.versao;

                        // Atualizar a instalação de produto com o cliente criado:
                        // Se codigoInstalaçao == 0, colocar na instalacão que ainda será criada; Se codigoInstalaçao != 0, utilizar a API
                        if (this.instalacaoOrigem.codigo == 0) {
                            this.instalacaoOrigem.clienteVinculado = new Array<Cliente>();
                            this.instalacaoOrigem.clienteVinculado.push(this.clienteOrigem);
                        } else {
                            this.catalogoApi.vinculacaoClienteInstalacaoProduto(this.instalacaoOrigem.codigo, this.instalacaoOrigem.versao, this.clienteOrigem)
                                .subscribe(
                                    resp => {

                                    },
                                    error => {
                                        this.modalService.exibirMensagem('Erro', 'Erro ao vincular cliente ao hostname de origem informado', 'Fechar');

                                    });
                        }
                    },
                    error => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao salvar cliente vinculado ao hostname de origem informado', 'Fechar');

                    });

        }

        // Verifica Cliente Destino
        user = new userAutorizador();
        if (this.clienteDestino.codTipoCliente == 1 && this.clienteDestino.userAplicacao.codUserAplicacao == 0) {
            user.username = this.clienteDestino.userAplicacao.nomeUserAplicacao;
            user.descricao = this.clienteDestino.userAplicacao.descricaoUserAplicacao;
            user.senha = 'connect';

            this.catalogoApi.criaEditaUsuario(0, 0, user)
                .subscribe(
                    resp => {
                        this.clienteDestino.userAplicacao.codUserAplicacao = resp.codigo;
                        this.clienteDestino.userAplicacao.versaoUserAplicacao = resp.versao;

                        // Atualizar a instalação de produto com o cliente criado:
                        // Se codigoInstalaçao == 0, colocar na instalacão que ainda será criada; Se codigoInstalaçao != 0, utilizar a API
                        if (this.instalacaoDestino.codigo == 0) {
                            this.instalacaoDestino.clienteVinculado = new Array<Cliente>();
                            this.instalacaoDestino.clienteVinculado.push(this.clienteDestino);
                        } else {
                            this.catalogoApi.vinculacaoClienteInstalacaoProduto(this.instalacaoDestino.codigo, this.instalacaoDestino.versao, this.clienteDestino)
                                .subscribe(
                                    resp => {

                                    },
                                    error => {
                                        this.modalService.exibirMensagem('Erro', 'Erro ao vincular cliente ao hostname de destino informado', 'Fechar');

                                    });
                        }
                    },
                    error => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao salvar cliente vinculado ao hostname de destino informado', 'Fechar');

                    });
        }
    }

    // Monta runtask no PNODE para operação após transferência bem sucedida
    runtaskPnodeAposTransf() {
        let pgm = '';
        let sysopts = '';
        let sOperacional = '';
        this.instalacaoOrigem.parmInstalacaoProduto.forEach(parm => {
            if (parm.parmNome == 'sistema_operacional') {
                sOperacional = parm.parmConteudo[0].conteudo;
            }
        });
        if (sOperacional == 'WINDOWS') {
            pgm = 'WINDOWS';
            sysopts =
                this.fluxoForm.value.aposTransf == '2' ?
                    'cmd(del /f ' + this.fluxoForm.value.dirOrigem + this.fluxoForm.value.arqOrigem + ')' :
                    'cmd(move /f ' + this.fluxoForm.value.dirOrigem + this.fluxoForm.value.arqOrigem + ' ' + this.fluxoForm.value.moverPara + this.fluxoForm.value.arqOrigem + ')';
        } else {
            pgm = 'UNIX';
            sysopts =
                this.fluxoForm.value.aposTransf == '2' ?
                    'rm -f ' + this.fluxoForm.value.dirOrigem + this.fluxoForm.value.arqOrigem :
                    'mv -f ' + this.fluxoForm.value.dirOrigem + this.fluxoForm.value.arqOrigem + ' ' + this.fluxoForm.value.moverPara + this.fluxoForm.value.arqOrigem;
        }
        return this.montaRuntask('0', '=', 'TASK', 'PNODE', pgm, sysopts);
    }

    // Monta runtask no SNODE para executar script/rotina após transferência bem sucedida
    runtaskSnodeAposTransf() {
        let pgm = '';
        let sysopts = '';
        let sOperacional = '';
        if (this.fluxoForm.value.tipoDestino == 'mainframe') {
            sOperacional = 'mainframe';
        } else {
            this.instalacaoDestino.parmInstalacaoProduto.forEach(parm => {
                if (parm.parmNome == 'sistema_operacional') {
                    sOperacional = parm.parmConteudo[0].conteudo;
                }
            });
        }
        if (sOperacional == 'mainframe') {
            pgm = 'DGADTSUB';
            sysopts = 'C\'DSN=DSS.CDTP01.JCL.FILE(GMTECTMR),DISP=SHR\' C\'TABELA ' + this.fluxoForm.value.rotinaDestino.substr(0, 3) +
                '\', C\'SCHEDULE ' + this.fluxoForm.value.rotinaDestino + '\', C\'DT &$DT_DD.&$DT_MM.&$DT_AA.\', C\'FILE ' + this.fluxoForm.value.arqDestino + '\'';
        } else if (sOperacional == 'WINDOWS') {
            pgm = 'WINDOWS';
            sysopts = 'cmd(' + this.fluxoForm.value.rotinaDestino + ')';
        } else {
            pgm = 'UNIX';
            sysopts = this.fluxoForm.value.rotinaDestino;

        }
        return this.montaRuntask('0', '=', 'TASK', 'SNODE', pgm, sysopts);
    }

    // Monta uma nova runtask, calculando o número sequencial -> Run1, Run2, ....
    montaRuntask(rc_cond, simbolo_rc, type, node, pgm, sysopts): Array<Parametro> {
        let parms = new Array<Parametro>();
        if (this.numRunTask == 1) {
            parms.push(this.novoParametro('rc_cond_run', rc_cond));
            parms.push(this.novoParametro('simbolo_rc_cond', simbolo_rc));
        }
        parms.push(this.novoParametro('run' + this.numRunTask + '_type', type));
        parms.push(this.novoParametro('run' + this.numRunTask + '_node', node));
        parms.push(this.novoParametro('run' + this.numRunTask + '_pgm', pgm));
        parms.push(this.novoParametro('run' + this.numRunTask + '_sysopts', sysopts));
        this.numRunTask++;
        return parms;
    }

    // Retorna um novo Parâmetro para os Eventos (transmissão, operação e processamento)
    novoParametro(parmNome: string, conteudo: string): Parametro {
        let parmTransmissao: Parametro = new Parametro();
        let parmConteudo: ParametroConteudo = new ParametroConteudo();
        parmTransmissao.parmConteudo = new Array<ParametroConteudo>();
        parmTransmissao.parmNome = parmNome;
        parmConteudo.nrPosicao = 0;
        parmConteudo.conteudo = conteudo;
        parmTransmissao.parmConteudo.push(parmConteudo);
        return parmTransmissao;
    }

    temOperacao(): Boolean {
        if ($('.checkOperacao:checked').length > 0) {
            return true;
        }
        return false;
    }

    // Função que retorna os eventos de Operação correspondentes às operações selecionadas
    eventosOperacao(): Array<Evento> {

        let eventos = new Array<Evento>();
        let temp = new Array<string>();


        $('.checkOperacao:checked').each(function () {
            temp.push($(this).val());
        });

        temp.forEach(element => {

            // Novo evento
            let evt: Evento = new Evento();
            evt.evento = this.numEvento;
            evt.etapa = this.numEvento;

            // alterado por Joelson
            // evt.grupo = 1;

            let varGrupo1: Number = 1;
            evt.grupo.push(varGrupo1);

            evt.descricao = 'Operação criada automaticamente através do fluxo simplificado';
            evt.codTipoEvento = 2;
            evt.codTipoTrigger = 4;
            evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

            //  evt.mensagemParaProtocolo = "Mensagem para protocolo";
            evt.mensagemParaProtocoloEmSucesso = '';
            evt.mensagemParaProtocoloEmErro = '';

            evt.servicosVinculados = this.servicosVinculados;
            evt.subfluxoVinculado = [];
            evt.subfluxoVinculado.push(1);

            evt.dependencia = new Array<Dependencia>();
            let dep = new Dependencia();
            dep.eventoAnterior = this.numEvento - 1;
            dep.codRetornoMin = 0;
            dep.codRetornoMax = 0;

            // dep.qtdSegundosMaxEntreEventos = 0;
            evt.qtdSegundosMaxEntreEventos = 0;

            evt.dependencia.push(dep);

            // Novo evento Operação
            let eventoOperacao = new EventoOperacao();

            // Definir parâmetros operação
            eventoOperacao.parmOperacao = new Array<Parametro>();

            switch (element) {
                case 'descompactar':
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoDescompacta;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('tipo', $('#tipoArqCompactado').val()));
                    break;
                case 'layout':
                    let mapa = this.novoMapa;
                    if (mapa == '') {
                        mapa = $('select[id=mapaConversao]').val();
                    }
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoConverteLayout;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('mapaConversao', mapa));
                    break;
                case 'compactar':
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoCompacta;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('tipo', $('#tipoArqCompactado2').val()));
                    break;
                case 'inserirHeader':
                    eventoOperacao.codOperacao = this.globalService.getConfiguracao().codOperacaoInsereHeader;
                    eventoOperacao.vrsOperacao = 1;
                    eventoOperacao.parmOperacao.push(this.novoParametro('arquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
                    eventoOperacao.parmOperacao.push(this.novoParametro('conteudoHeader', $('#conteudoHeader').val()));
                    eventoOperacao.parmOperacao.push(this.novoParametro('conteudoTrailer', $('#conteudoTrailer').val()));
                    break;
            }

            evt.detalheEventoOperacao = eventoOperacao;

            this.numEvento++;
            eventos.push(evt);
        });
        return eventos;
    }


    // Primeiro evento de transmissão via SIA para um outro cliente SIA
    transmissaoSIAparaSIA1(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEvento;

        // alteradp por Joelson
        // evt.grupo = 1;
        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 2;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'SIA';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.instalacaoOrigem.codigo;
        origem.vrsInstalacaoProdutoOrigem = this.instalacaoOrigem.versao;
        origem.clienteOrigem = this.clienteOrigem;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
        destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;

        // Se o FTA tem operação, o cliente destino é o cliente origem. O cliente destino será informado na última transmissão
        this.temOperacao() ?
            //destino.clienteDestino = this.clienteOrigem :
            destino.clienteDestino = null :
            destino.clienteDestino = this.clienteDestino;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemRegex', '.*'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('NomeArquivoDestino', this.fluxoForm.value.arqDestino.trim()));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        return evt;

    }

    // Segundo evento de transmissão via SIA para um outro cliente SIA caso existam operações selecionadas
    transmissaoSIAparaSIA2(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEvento;

        // alterado por Joelson
        // evt.grupo = 1;
        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 4;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        //alterado por Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        evt.dependencia = new Array<Dependencia>();
        let dep = new Dependencia();
        dep.eventoAnterior = this.numEvento - 1;
        dep.codRetornoMin = 0;
        dep.codRetornoMax = 0;

        //alterado por Joelson
        // dep.qtdSegundosMaxEntreEventos = 0;
        evt.qtdSegundosMaxEntreEventos = 0;

        evt.dependencia.push(dep);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem - BB.DSSIA
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoConnectSIA;
        origem.vrsInstalacaoProdutoOrigem = 1;

        let clienteSIA = new Cliente();
        clienteSIA.codTipoCliente = 1;
        clienteSIA.userAplicacao = new UserAplicacao();
        clienteSIA.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteSIA;
        clienteSIA.userAplicacao.versaoUserAplicacao = 1;
        origem.clienteOrigem = clienteSIA;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino - BB.DESGMT
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
        destino.vrsInstalacaoProdutoDestino = 1;

        // Cliente B2B
        let clienteB2B = new Cliente();
        clienteB2B.codTipoCliente = 1;
        clienteB2B.userAplicacao = new UserAplicacao();
        clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
        clienteB2B.userAplicacao.versaoUserAplicacao = 1;
        destino.clienteDestino = clienteB2B;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
            '/dados/recebidos/&{' + (this.numEvento - 1).toString() + '}ArquivoGeradoSIANome.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        return evt;

    }

    // Terceiro evento de transmissão via SIA para um outro cliente SIA caso existam operações selecionadas
    transmissaoSIAparaSIA3(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEvento;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 4;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado por Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Dependência do evento anterior
        evt.dependencia = new Array<Dependencia>();
        let dep = new Dependencia();
        dep.eventoAnterior = this.numEvento - 1;
        dep.codRetornoMin = 0;
        dep.codRetornoMax = 0;

        // alterado por Joelson
        // dep.qtdSegundosMaxEntreEventos = 0;
        evt.qtdSegundosMaxEntreEventos = 0;

        evt.dependencia.push(dep);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'SIA';

        // Dados Origem - SIA_PADRAO
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
        origem.vrsInstalacaoProdutoOrigem = 1;

        // Cliente B2B
        let clienteB2B = new Cliente();
        clienteB2B.codTipoCliente = 1;
        clienteB2B.userAplicacao = new UserAplicacao();
        clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
        clienteB2B.userAplicacao.versaoUserAplicacao = 1;
        origem.clienteOrigem = clienteB2B;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
        destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;
        destino.clienteDestino = this.clienteDestino;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '&{1}ArquivoOrigem.'));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        return evt;

    }

    // Primeiro evento de transmissão via SIA para um servidor interno do Banco do Brasil
    transmissaoSIAparaBB1(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEvento;

        // alterado por Joelson
        // evt.grupo = 1;
        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 2;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado por Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'SIA';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.instalacaoOrigem.codigo;
        origem.vrsInstalacaoProdutoOrigem = this.instalacaoOrigem.versao;
        origem.clienteOrigem = this.clienteOrigem;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        /* destino.codInstalacaoProdutoDestino = this.instalacaoOrigem.codigo;
        destino.vrsInstalacaoProdutoDestino = this.instalacaoOrigem.versao; */
        //destino.clienteDestino = this.clienteOrigem;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemRegex', '.*'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '&ArquivoOrigem.'));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        return evt;

    }

    // Segundo evento de transmissão via SIA para um servidor interno do Banco do Brasil
    transmissaoSIAparaBB2(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEvento;

        //alterado por Joelson
        //evt.grupo = 1;
        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 4;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // alterado Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';


        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Dependência do evento anterior
        evt.dependencia = new Array<Dependencia>();
        let dep = new Dependencia();
        dep.eventoAnterior = this.numEvento - 1;
        dep.codRetornoMin = 0;
        dep.codRetornoMax = 0;

        // dep.qtdSegundosMaxEntreEventos = 0;
        evt.qtdSegundosMaxEntreEventos = 0;

        evt.dependencia.push(dep);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem - BB.DSSIA
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoConnectSIA;
        origem.vrsInstalacaoProdutoOrigem = 1;

        let clienteSIA = new Cliente();
        clienteSIA.codTipoCliente = 1;
        clienteSIA.userAplicacao = new UserAplicacao();
        clienteSIA.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteSIA;
        clienteSIA.userAplicacao.versaoUserAplicacao = 1;
        origem.clienteOrigem = clienteSIA;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
        destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;
        destino.clienteDestino = this.clienteDestino;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{1}ArquivoGeradoSIAFisico.'));
        //eventoTransmissao.parmTransmissao.push(this.novoParametro("ArquivoOrigem", "&{" + (this.numEvento - 1).toString() + "}ArquivoDestino."));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', this.fluxoForm.value.dirDestino + this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestino)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));

        // Parâmetros específicos do mainframe
        if (this.fluxoForm.value.tipoDestino == 'mainframe') {
            eventoTransmissao.parmTransmissao.push(this.novoParametro('recfm', this.fluxoForm.value.recfm));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('lrecl', this.fluxoForm.value.lrecl));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('blksize', this.fluxoForm.value.blksize));
        }

        // Montar runtask no SNODE para executar script/rotina após transferência bem sucedida
        if (this.fluxoForm.value.rotinaDestino != '') {
            this.runtaskSnodeAposTransf().forEach(element => {
                eventoTransmissao.parmTransmissao.push(element);
            });
        }

        evt.detalheEventoTransmissao = eventoTransmissao;
        this.numEvento++;
        return evt;
    }

    // Primeiro evento de transmissão de um servidor interno do Banco do Brasil para um cliente SIA
    transmissaoBBparaSIA1(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEvento;

        //alterado por Joelson
        //evt.grupo = 1;
        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 2;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        if (this.fluxoForm.value.tipoOrigem == 'mainframe') {
            evt.codTipoTrigger = 1;
        }

        origem.codInstalacaoProdutoOrigem = this.instalacaoOrigem.codigo;
        origem.vrsInstalacaoProdutoOrigem = this.instalacaoOrigem.versao;
        origem.clienteOrigem = this.clienteOrigem;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino - BB.DESGMT
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
        destino.vrsInstalacaoProdutoDestino = 1;

        let clienteB2B = new Cliente();
        clienteB2B.codTipoCliente = 1;
        clienteB2B.userAplicacao = new UserAplicacao();
        clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
        clienteB2B.userAplicacao.versaoUserAplicacao = 1;
        destino.clienteDestino = clienteB2B;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemRegex',
            this.nomeArqToRegex(this.fluxoForm.value.dirOrigem + this.fluxoForm.value.arqOrigem)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '/dados/recebidos/&ArquivoOrigem.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', 'NEW'));

        // Montar runtask no PNODE para operação após transferência bem sucedida
        if (this.fluxoForm.value.aposTransf != '1') {
            this.runtaskPnodeAposTransf().forEach(element => {
                eventoTransmissao.parmTransmissao.push(element);
            });
        }

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        return evt;
    }

    // Primeiro evento de transmissão de um servidor interno do Banco do Brasil para um cliente SIA
    transmissaoBBparaSIA2(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEvento;

        //alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 4;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        //alterado por Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        evt.dependencia = new Array<Dependencia>();
        let dep = new Dependencia();
        dep.eventoAnterior = this.numEvento - 1;
        dep.codRetornoMin = 0;
        dep.codRetornoMax = 0;

        // alterado por Joelson
        // dep.qtdSegundosMaxEntreEventos = 0;
        evt.qtdSegundosMaxEntreEventos = 0;

        evt.dependencia.push(dep);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'SIA';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoSIAPadrao;
        origem.vrsInstalacaoProdutoOrigem = 1;

        let clienteB2B = new Cliente();

        if (this.fluxoForm.value.tipoOrigem == 'mainframe') {
            clienteB2B = this.clienteOrigem;
        } else {
            clienteB2B.codTipoCliente = 1;
            clienteB2B.userAplicacao = new UserAplicacao();
            clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
            clienteB2B.userAplicacao.versaoUserAplicacao = 1;
        }
        origem.clienteOrigem = clienteB2B;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
        destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;
        destino.clienteDestino = this.clienteDestino;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemRegex', '.*'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemB2B', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
            this.fluxoForm.value.dirDestino + this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestino)));

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        return evt;
    }

    // Primeiro evento de transmissão de um servidor interno do Banco do Brasil para outro servidor do Banco do Brasil
    transmissaoBBparaBB1(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEvento;

        //alterado por Joelson
        //evt.grupo = 1;
        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 2;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        //alterado por Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        if (this.fluxoForm.value.tipoOrigem == 'mainframe') {
            evt.codTipoTrigger = 1;
        }

        origem.codInstalacaoProdutoOrigem = this.instalacaoOrigem.codigo;
        origem.vrsInstalacaoProdutoOrigem = this.instalacaoOrigem.versao;

        origem.clienteOrigem = this.clienteOrigem;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();

        // Se o FTA tem operação, o cliente/instalação destino é o B2B. O cliente destino será informado na última transmissão
        if (this.temOperacao()) {
            let clienteB2B = new Cliente();
            clienteB2B.codTipoCliente = 1;
            clienteB2B.userAplicacao = new UserAplicacao();
            clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
            clienteB2B.userAplicacao.versaoUserAplicacao = 1;

            destino.codInstalacaoProdutoDestino = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
            destino.vrsInstalacaoProdutoDestino = 1;
            destino.clienteDestino = clienteB2B;
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino', '/dados/recebidos/&ArquivoOrigem.'));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', 'NEW'));
        } else {
            destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
            destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;
            destino.clienteDestino = this.clienteDestino;
            eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
                this.fluxoForm.value.dirDestino + this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestino)));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));
        }

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigemRegex',
            this.nomeArqToRegex(this.fluxoForm.value.dirOrigem + this.fluxoForm.value.arqOrigem)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));


        // Parâmetros específicos do mainframe
        if (this.fluxoForm.value.tipoDestino == 'mainframe' && !this.temOperacao()) {
            eventoTransmissao.parmTransmissao.push(this.novoParametro('recfm', this.fluxoForm.value.recfm));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('lrecl', this.fluxoForm.value.lrecl));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('blksize', this.fluxoForm.value.blksize));
        }

        // Montar runtask no PNODE para operação após transferência bem sucedida
        if (this.fluxoForm.value.aposTransf != '1') {
            this.runtaskPnodeAposTransf().forEach(element => {
                eventoTransmissao.parmTransmissao.push(element);
            });
        }

        // Montar runtask no SNODE para executar script/rotina após transferência bem sucedida
        if (this.fluxoForm.value.rotinaDestino != '' && !this.temOperacao()) {
            this.runtaskSnodeAposTransf().forEach(element => {
                eventoTransmissao.parmTransmissao.push(element);
            });
        }

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        return evt;
    }

    // Segundo evento de transmissão de um servidor interno do Banco do Brasil para outro servidor do Banco do Brasil
    transmissaoBBparaBB2(): Evento {

        // Novo evento
        let evt: Evento = new Evento();
        evt.evento = this.numEvento;
        evt.etapa = this.numEvento;

        // alterado por Joelson
        // evt.grupo = 1;

        let varGrupo1: Number = 1;
        evt.grupo.push(varGrupo1);

        evt.descricao = 'Transmissão criada automaticamente através do fluxo simplificado';
        evt.codTipoEvento = 1;
        evt.codTipoTrigger = 4;
        evt.codTipoPeriodicidade = this.fluxoForm.value.codTipoPeriodicidade;

        //alterado por Joelson
        // evt.mensagemParaProtocolo = "Mensagem para protocolo";
        evt.mensagemParaProtocoloEmSucesso = '';
        evt.mensagemParaProtocoloEmErro = '';

        evt.servicosVinculados = this.servicosVinculados;
        evt.subfluxoVinculado = [];
        evt.subfluxoVinculado.push(1);

        evt.dependencia = new Array<Dependencia>();
        let dep = new Dependencia();
        dep.eventoAnterior = this.numEvento - 1;
        dep.codRetornoMin = 0;
        dep.codRetornoMax = 0;

        //alterado por Joelson
        //dep.qtdSegundosMaxEntreEventos = 0;
        evt.qtdSegundosMaxEntreEventos = 0;

        evt.dependencia.push(dep);

        // Novo evento de transmissão
        let eventoTransmissao: EventoTransmissao = new EventoTransmissao();
        eventoTransmissao.nomeItemConfiguracaoProduto = 'Connect_Direct';

        // Dados Origem
        let origem: OrigemTransmissao = new OrigemTransmissao();
        origem.codInstalacaoProdutoOrigem = this.globalService.getConfiguracao().codInstalacaoConnectGMT;
        origem.vrsInstalacaoProdutoOrigem = 1;

        let clienteB2B = new Cliente();
        clienteB2B.codTipoCliente = 1;
        clienteB2B.userAplicacao = new UserAplicacao();
        clienteB2B.userAplicacao.codUserAplicacao = this.globalService.getConfiguracao().codClienteGMT;
        clienteB2B.userAplicacao.versaoUserAplicacao = 1;
        origem.clienteOrigem = clienteB2B;

        eventoTransmissao.origem = new Array<OrigemTransmissao>();
        eventoTransmissao.origem.push(origem);

        // Dados Destino
        let destino: DestinoTransmissao = new DestinoTransmissao();
        destino.codInstalacaoProdutoDestino = this.instalacaoDestino.codigo;
        destino.vrsInstalacaoProdutoDestino = this.instalacaoDestino.versao;
        destino.clienteDestino = this.clienteDestino;

        eventoTransmissao.destino = new Array<DestinoTransmissao>();
        eventoTransmissao.destino.push(destino);

        // Definir parâmetros de transmissão
        eventoTransmissao.parmTransmissao = new Array<Parametro>();
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoOrigem', '&{' + (this.numEvento - 1).toString() + '}ArquivoDestino.'));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('ArquivoDestino',
            this.fluxoForm.value.dirDestino + this.preparaVariaveisNomeArquivo(this.fluxoForm.value.arqDestino)));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_origem', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('datatype_destino', this.fluxoForm.value.tpArqOrigem));
        eventoTransmissao.parmTransmissao.push(this.novoParametro('disp', this.fluxoForm.value.arqExistente));

        // Parâmetros específicos do mainframe
        if (this.fluxoForm.value.tipoDestino == 'mainframe') {
            eventoTransmissao.parmTransmissao.push(this.novoParametro('recfm', this.fluxoForm.value.recfm));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('lrecl', this.fluxoForm.value.lrecl));
            eventoTransmissao.parmTransmissao.push(this.novoParametro('blksize', this.fluxoForm.value.blksize));
        }

        // Montar runtask no SNODE para executar script/rotina após transferência bem sucedida
        if (this.fluxoForm.value.rotinaDestino != '') {
            this.runtaskSnodeAposTransf().forEach(element => {
                eventoTransmissao.parmTransmissao.push(element);
            });
        }

        evt.detalheEventoTransmissao = eventoTransmissao;

        this.numEvento++;
        return evt;
    }

    salvarFluxo() {

        /* TODO - Validação do formulário */
        /* TODO - Mensagens de erro ao salvar/buscar dados do catálogo */

        this.numRunTask = 1;
        this.numEvento = 1;

        this.ftaService.novoFluxo();
        if (this.ftaService.fta.eventos == null) {
            this.ftaService.fta.eventos = new Array<Evento>();
        }

        // Dados FTA
        this.ftaService.fta.fta = 0;
        this.ftaService.fta.versao = 0;
        this.ftaService.fta.nome = this.fluxoForm.value.nome;
        this.ftaService.fta.descricao = this.fluxoForm.value.descricao;
        this.ftaService.fta.subfluxoVigente = 1;

        // Dados Subfluxo
        this.ftaService.fta.subfluxoPossiveis = new Array<SubfluxoPossivel>();
        let subfluxoPossivel = new SubfluxoPossivel();
        subfluxoPossivel.nrSubfluxo = 1;
        subfluxoPossivel.descricaoSubfluxo = 'Fluxo principal';
        this.ftaService.fta.subfluxoPossiveis.push(subfluxoPossivel);

        // Criar eventos de transmissão de acordo com ORIGEM/DESTINO:
        //  SIA -> SIA
        if (this.fluxoForm.value.tipoOrigem == 'web' && this.fluxoForm.value.tipoDestino == 'web') {
            this.ftaService.fta.eventos.push(this.transmissaoSIAparaSIA1());
            // Se tem operação selecionada, colocar as outras transmissões
            if (this.temOperacao()) {
                this.ftaService.fta.eventos.push(this.transmissaoSIAparaSIA2());
                this.eventosOperacao().forEach(element => {
                    this.ftaService.fta.eventos.push(element);
                });
                this.ftaService.fta.eventos.push(this.transmissaoSIAparaSIA3());
            }

            //  SIA -> BB
        } else if (this.fluxoForm.value.tipoOrigem == 'web' && this.fluxoForm.value.tipoDestino != 'web') {
            this.ftaService.fta.eventos.push(this.transmissaoSIAparaBB1());
            // Se tem operação selecionada, colocar as outras transmissões
            if (this.temOperacao()) {
                this.ftaService.fta.eventos.push(this.transmissaoSIAparaSIA2());
                this.eventosOperacao().forEach(element => {
                    this.ftaService.fta.eventos.push(element);
                });
            }
            this.ftaService.fta.eventos.push(this.transmissaoSIAparaBB2());

            //  BB -> SIA
        } else if (this.fluxoForm.value.tipoOrigem != 'web' && this.fluxoForm.value.tipoDestino == 'web') {
            this.ftaService.fta.eventos.push(this.transmissaoBBparaSIA1());
            this.eventosOperacao().forEach(element => {
                this.ftaService.fta.eventos.push(element);
            });
            this.ftaService.fta.eventos.push(this.transmissaoBBparaSIA2());

            //  BB -> BB
        } else {
            this.ftaService.fta.eventos.push(this.transmissaoBBparaBB1());
            // Se tem operação selecionada, colocar as outras transmissões
            if (this.temOperacao()) {
                this.eventosOperacao().forEach(element => {
                    this.ftaService.fta.eventos.push(element);
                });
                this.ftaService.fta.eventos.push(this.transmissaoBBparaBB2());
            }
        }


        this.resumoFta();

    }

    // Monta objeto de resumo para confirmação dos dados inseridos antes de salvar o FTA
    resumoFta() {

        // Origem
        this.ftaService.resumoFTA.tipoOrigem = this.fluxoForm.value.tipoOrigem;
        this.ftaService.resumoFTA.arqOrigem = this.fluxoForm.value.dirOrigem + this.fluxoForm.value.arqOrigem;
        this.ftaService.resumoFTA.ambienteMFOrigem = this.fluxoForm.value.ambienteMFOrigem;
        this.ftaService.resumoFTA.hostnameOrigem = this.hostnameOrigem.value;
        this.ftaService.resumoFTA.uorOrigem = this.uorOrigem.value;
        this.ftaService.resumoFTA.tpArqOrigem = this.fluxoForm.value.tpArqOrigem;
        this.ftaService.resumoFTA.aposTransf = this.fluxoForm.value.aposTransf;
        this.ftaService.resumoFTA.moverPara = this.fluxoForm.value.moverPara;

        // Operações
        this.ftaService.resumoFTA.descompactar = '';
        this.ftaService.resumoFTA.layout = '';
        this.ftaService.resumoFTA.compactar = '';
        this.ftaService.resumoFTA.inserirHeader = '';
        this.ftaService.resumoFTA.inserirTrailer = '';

        if (this.descompactar.value == true) {
            this.ftaService.resumoFTA.descompactar = this.tipoArqCompactado.value;
        }
        if (this.layout.value == true) {
            let mapa = this.novoMapa;
            if (mapa == '') {
                mapa = $('select[id=mapaConversao]').val();
            }
            this.ftaService.resumoFTA.layout = mapa;
        }
        if (this.compactar.value == true) {
            this.ftaService.resumoFTA.compactar = this.tipoArqCompactado2.value;
        }
        if (this.inserirHeader.value == true) {
            this.ftaService.resumoFTA.inserirHeader = this.conteudoHeader.value;
            this.ftaService.resumoFTA.inserirTrailer = this.conteudoTrailer.value;

        }

        // Destino
        this.ftaService.resumoFTA.tipoDestino = this.fluxoForm.value.tipoDestino;
        this.ftaService.resumoFTA.arqDestino = this.fluxoForm.value.dirDestino + this.montaArqDestino;
        this.ftaService.resumoFTA.ambienteMFDestino = this.fluxoForm.value.ambienteMFDestino;
        this.ftaService.resumoFTA.hostnameDestino = this.hostnameDestino.value;
        this.ftaService.resumoFTA.uorDestino = this.uorDestino.value;
        this.ftaService.resumoFTA.arqExistente = this.fluxoForm.value.arqExistente;
        this.ftaService.resumoFTA.recfm = this.fluxoForm.value.recfm;
        this.ftaService.resumoFTA.lrecl = this.fluxoForm.value.lrecl;
        this.ftaService.resumoFTA.blksize = this.fluxoForm.value.blksize;
        this.ftaService.resumoFTA.rotinaDestino = this.fluxoForm.value.rotinaDestino;

        // Abrir página modal com o Resumo do FTA
        this.modalService.abrirPaginaModal('resumo-fta-modal', {}, {},
            '<div class=\'text-center titulo\'>Resumo - Fluxo de Transmissão de Arquivos</div><hr class=\'decoracao-titulo\' />', 'Fechar')
            .subscribe(resp => {

                // Após confirmação do usuário, salvar FTA
                if (resp == 'confirmar') {

                    this.globalService.loading = true;

                    // TODO - Esses três têm que ser síncronos!!!!
                    this.verificarCliente();
                    this.verificarInstalacaoProduto();
                    this.catalogoApi.criaEditaFta(0, 0, this.ftaService.fta)
                        .subscribe(
                            resposta => {
                                this.ftaService.msgFtaSalvo = 'sucesso';
                                this.ftaService.numFtaSalvo = resposta.codigoCriado;
                                this.globalService.loading = false;
                                this.router.navigate(['/home']);
                                return false;
                            },
                            erro => {
                                this.ftaService.msgFtaSalvo = 'erro';
                                this.globalService.loading = false;
                                this.router.navigate(['/home']);
                                return false;
                            }
                        );
                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/fluxo-cliente-interno/fluxo-cliente-interno.ts